import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
// import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginComponent } from './components/no-auth/login/login.component';
import {SharedModule} from './Shared/modules/shared.module';
import {AuthGuard} from './Shared/guards/auth.guard';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import {HttpInterceptorService} from './Shared/services/app-services/http-interceptor.service';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {ToastrModule} from 'ngx-toastr';
import {StoreModule} from '@ngrx/store';
import {reducers} from 'src/app/store/reducers';
import { ResetPasswordComponent } from './components/no-auth/reset-password/reset-password.component';
import { UpdatePasswordComponent } from './components/no-auth/update-password/update-password.component';
import {CommonModule} from '@angular/common';
import {FormsModule} from "@angular/forms";
import {environment as ENV} from '../environments/environment';

import * as firebase from 'firebase/app';
import 'firebase/storage';
import 'firebase/analytics';
import { ResetPasswordTokenComponent } from './components/no-auth/reset-password-token/reset-password-token.component';
// import { ViewDocumentDetailsComponent } from './components/pages/files/view-document-details/view-document-details.component';

firebase.initializeApp(ENV.FIREBASE);
firebase.analytics();

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    ResetPasswordComponent,
    UpdatePasswordComponent,
    ResetPasswordTokenComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    BrowserAnimationsModule,
    SharedModule,
    AppRoutingModule,
    HttpClientModule,
    CommonModule,
    ToastrModule.forRoot({ closeButton: true, preventDuplicates: true, enableHtml: true}),
    StoreModule.forRoot(reducers)
  ],
  providers: [
    HttpClientModule,
    AuthGuard,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpInterceptorService,
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
